<template>
  <div class="col-xs-12">
    <form id="form-planos" action="creditos" method="post">

      <div class="row">
        <div class="row">
          <div class="col-xs-12">
            <div class="row">
              <div class="col-md-6">
                <div class="form-box form-box-margin form-creditos">
                  <label class="label" for="precoPorCredito">Valor da Recarga</label>
                  <div class="range-slider">
                    <input id="rs-range-line" class="rs-range" type="range" step="50" :min="usuario.valorMinimoCompra" :max="precoMaximo" v-model="sliderValue" @input="identificarPreenchimentoFormulario">
                  </div>
                  <money v-model="creditos" v-bind="money"></money>
                  <span class="Message -fail display-span" v-if="creditoInvalido"> O saldo deve estar entre R$ {{usuario.valorMinimoCompra}} e R$ {{precoMaximo}}</span>
                  <span class="Message" v-if="usuario.validadeCreditos"><br>Válido até {{ usuario.validadeCreditos }}</span>
                </div>
                <p class="descricao-desconto" v-if="bonus > 0" style="color: green;">
                  + R$ {{ (bonus).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} (Bônus)
                </p>
              </div>
              <div class="col-md-6 form-creditos" v-if="this.pagamentoAntigo">
                <!-- <div class="like-tooltip" v-show="tooltip"> -->
                <p class="label">Bônus na recarga</p>
                <div class="like-tooltip">
                  <p class="like-tooltip-line"><b>+11% de bônus:</b> A partir de R$ 1.050,00 </p>
                  <p class="like-tooltip-line"><b>+25% de bônus:</b> A partir de R$ 2.700,00 </p>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-md-12">
              <p class="heading -likeH4 -spaceTop">Dados de cobrança</p>
            </div>

            <div class="col-md-6">
              <div class="form-box form-creditos">
                <label class="label">Nome completo ou Razão social</label>
                <input
                name="nome"
                v-model="form.nome"
                class="input is-large"
                type="text"
                required="required"
                autofocus="autofocus"
                @input="identificarPreenchimentoFormulario"
                >
                <span v-if="message.fail.nome" class="Message -fail">{{message.fail.nome}}</span>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-box form-creditos">
                <label class="label">CPF/CNPJ</label>
                <the-mask
                    v-model="form.cpfCnpj"
                    :mask="['###.###.###-##', '##.###.###/####-##']"
                    type="tel"
                    name="form.cpfCnpj"
                    class="field"
                    required="required"
                    placeholder="00.000.000/0000-00"
                    @input.native="verificarCnpj"
                />
                <span v-if="message.fail.cpfCnpj" class="Message -fail">{{message.fail.cpfCnpj}}</span>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-box form-creditos">
                <label class="label">Telefone</label>
                <input
                  name="form.telefoneArea"
                  class="field"
                  type="tel"
                  required="required"
                  v-model="form.telefoneArea"
                  placeholder="00"
                  maxlength="2"
                  style="width: 20%"
                  @input="identificarPreenchimentoFormulario"
                >

                <the-mask
                    name="form.telefone"
                    class="field"
                    type="tel"
                    required="required"
                    v-model="form.telefone"
                    :mask="['####-####', '#####-####']"
                    placeholder="00000-0000"
                    style="width: 78%"
                    @input.native="() => identificarPreenchimentoFormulario()"
                />
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <span v-if="message.fail.telefoneArea" class="Message -fail">{{message.fail.telefoneArea}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span v-if="message.fail.telefone" class="Message -fail">{{message.fail.telefone}}</span>
            </div>
          </div>

          <div class="row">
            <div class="form-box form-box-width -radio -center">
              <div class="field-box -radio">
                <input class='field' type="radio" name="formaPagamento" value="CARTAO_CREDITO" id="cartao"
                v-model="form.formaPagamento">
                <label for="cartao" class="label no-padding">Cartão de crédito</label>
              </div>
              <div class="field-box -radio">
                <input class='field' type="radio" name="formaPagamento" value="BOLETO" id="boleto"
                v-model="form.formaPagamento">
                <label for="boleto" class="label no-padding">Boleto</label>
              </div>
              <div class="field-box -radio">
                <input class='field' type="radio" name="formaPagamento" value="PIX" id="pix"
                       v-model="form.formaPagamento">
                <label for="pix" class="label no-padding">PIX</label>
              </div>
            </div>
          </div>

          <div v-if="isCnpj || form.formaPagamento === 'BOLETO' || form.formaPagamento === 'PIX'">
            <label class="label label-title" for="enderecoRua">Endereço</label>

            <div class="row">
              <div class="col-md-3">
                <div class="form-box form-creditos">
                  <label class="label" for="enderecoCEP">CEP</label>
                  <the-mask
                    name="enderecoCep"
                    v-model="form.enderecoCep"
                    class="field"
                    type="tel"
                    required="required"
                    mask="#####-###"
                    @input.native="updateInputCEP"
                    id="enderecoCEP" />
                  <div v-if="buscaPorCep"></div>
                  <span v-if="message.fail.enderecoCep" class="Message -fail">{{message.fail.enderecoCep}}</span>
                </div>
              </div>

              <div class="col-md-9">
                <div class="form-box form-creditos">
                  <label class="label" for="enderecoRua">Rua</label>
                  <input
                    name="enderecoRua"
                    v-model="form.enderecoRua"
                    class="field"
                    type="text"
                    required="required"
                    id="enderecoRua"
                    :readonly="buscaPorCep"
                  >
                  <span v-if="message.fail.enderecoRua" class="Message -fail">{{message.fail.enderecoRua}}</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-box form-creditos">
                  <label class="label" for="complemento">Complemento</label>
                  <input
                    name="complemento"
                    v-model="form.complemento"
                    class="field"
                    type="text"
                    id="complemento"
                  >
                  <span v-if="message.fail.complemento" class="Message -fail">{{message.fail.complemento}}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-box form-creditos">
                  <label class="label">Número</label>
                  <input
                    name="enderecoNumero"
                    v-model="form.enderecoNumero"
                    :disabled="form.semNumero"
                    class="field"
                    type="text"
                    required="required"
                    id="enderecoNumero"
                  >
                  <span v-if="message.fail.enderecoNumero" class="Message -fail">{{message.fail.enderecoNumero}}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-box form-creditos Form__number">
                  <input
                    v-model="form.semNumero"
                    id="semNumero"
                    name="semNumero"
                    class="checkbox"
                    type="checkbox"
                    required="required"
                    @click="toggleSemNumero"
                  >
                  <label for="semNumero" class="label">Sem número</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-box form-creditos">
                  <label class="label" for="enderecoBairro">Bairro</label>
                  <input
                    name="enderecoBairro"
                    v-model="form.enderecoBairro"
                    class="field"
                    type="text"
                    required="required"
                    id="enderecoBairro"
                    :readonly="buscaPorCep"
                  >
                  <span v-if="message.fail.enderecoBairro" class="Message -fail">{{message.fail.enderecoBairro}}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-box form-creditos">
                  <label class="label">Cidade</label>
                  <input
                    name="enderecoCidade"
                    v-model="form.enderecoCidade"
                    class="field"
                    type="text"
                    required="required"
                    :readonly="buscaPorCep"
                  >
                  <span v-if="message.fail.enderecoCidade" class="Message -fail">{{message.fail.enderecoCidade}}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-box form-creditos">
                  <label class="label">Estado</label>
                  <input
                    name="enderecoEstado"
                    v-model="form.enderecoEstado"
                    class="field"
                    type="text"
                    required="required"
                    :readonly="buscaPorCep"
                  >
                  <span v-if="message.fail.enderecoEstado" class="Message -fail">{{message.fail.enderecoEstado}}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="form.formaPagamento === 'CARTAO_CREDITO'" class="Section__cartao">
            <label class="label label-title" for="enderecoRua">Cartão de Crédito</label>

            <input
            name="cardPaymentToken"
            class="field"
            type="hidden"
            required="required"
            v-model="form.cardPaymentToken"
            >

            <div class="row">
              <div class="col-md-6">
                <div class="form-box form-creditos">
                  <div class="CardBrand" :class="cardBrand"></div>
                  <the-mask
                    name="cardNumber"
                    v-model="cardNumber"
                    class="field CardNumber"
                    type="tel"
                    required="required"
                    placeholder="Número do cartão"
                    mask="#### #### #### ####" />
                  <span v-if="message.fail.cardNumber" class="Message -fail">{{message.fail.cardNumber}}</span>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-box form-creditos">
                  <input
                  name="cardHolderName"
                  v-model="form.cardHolderName"
                  class="field"
                  type="text"
                  required="required"
                  placeholder="Nome no cartão"
                  >
                  <span v-if="message.fail.cardHolderName" class="Message -fail">{{message.fail.cardHolderName}}</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-box form-creditos">
                  <select name="cardMonth"
                  v-model="form.cardMonth"
                  class="field"
                  >
                  <option v-for="n in 12" :value="n.pad(2)">{{ n.pad(2) }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-box form-creditos">
                <select name="cardYear"
                v-model="form.cardYear"
                class="field"
                >
                <option v-for="n in cardYears" :value="n">{{ n }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-box form-creditos">
              <input
              name="cardCvv"
              v-model="form.cardCvv"
              class="field"
              type="tel"
              required="required"
              placeholder="CVV"
              >
              <span v-if="message.fail.cardCvv" class="Message -fail">{{message.fail.cardCvv}}</span>
            </div>
          </div>
        </div>
      </div>

      <button class="btn buy-credits-button" type="button" @click="revisarCompra">
        <svg class="svg-icon -left -x32 svg-shopping-cart">
          <use xlink:href="/assets/svg/user/icons.svg#svg-shopping-cart"></use>
        </svg>
        <b>REVISAR</b>
      </button>

      <div class="conexao-segura">
        <svg class="svg-icon -left -x20">
          <use xlink:href="/assets/svg/user/icons.svg#svg-lock"></use>
        </svg>
        <p>Conexão segura. Os dados de cobrança são utilizados apenas para compras e emissão de nota fiscal.</p>
      </div>

      <confirmar-pagamento-modal
        :form="form"
        :bonus="bonus"
        :quantidadeCreditos="creditos"
        :plano="plano"
        :visible="showModalConfirmarCompra"
        :buying="buying"
        :pagamentoAntigo="pagamentoAntigo"
        :validadeCreditos="usuario.validadeCreditos"
        @closeModal="closeModal"
        @comprarCreditos="comprarCreditos">
    </confirmar-pagamento-modal>
  </div>
</form>
<Loading></Loading>
</div>
</template>

<script>
  import {subdomainUrl} from "../../utils/url";
  import {validarCNPJ} from "../../utils/string";
  import {Money} from 'v-money'

  require('../../utils/number');
  import paymentFormHelper from './PaymentFormHelper';
  import usuarioApi from './../../api/usuario';
  import Loading from '../monitoramentos/Loading';
  import Form from './../../core/Form';

  export default {
    name: "cobranca",
    mixins: [paymentFormHelper],
    props: {
      usuario: {
        type: Object,
        default: {},
      },
      planos: {
        type: Object,
        default: [],
      },
      dadosCobranca: {
        type: Object,
        default: {}
      },
      ultimaCompraValor: {
        type: Number,
        default: {}
      },
    },
    components: {
      Loading,
      Money
    },
    data() {
      return {
        tooltip: false,
        sliderValue: 100,
        preco: 100.00,
        creditos: 100.00,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
        precoMaximo: '',
        message: {
          fail: {
            nome: '',
            cpfCnpj: '',
            telefoneArea: '',
            telefone: '',
            cardNumber: '',
            cardHolderName: '',
            cardCvv: '',
            enderecoCep: '',
            enderecoRua: '',
            enderecoBairro: '',
            enderecoCidade: '',
            enderecoEstado: '',
            enderecoNumero: '',
            complemento: '',
            plano: '',
          }
        },

        errors: {},
        // card_number: '',
        // card_holder_name: '',
        // card_cvv: '',
        plano: '',
        buscaPorCep: false,
        phoneMask: '99999-9999',
        cardNumber: '',
        isCnpj: false,
        form: new Form({
          nome: '',
          telefoneArea: this.usuario.telefoneArea,
          telefone: this.usuario.telefoneNumero,
          cardYear: new Date().getFullYear(),
          cardMonth: '01',
          cpfCnpj: '',
          cardPaymentToken: '',
          cardHolderName: '',
          cardLastFourDigits: '',
          cardCvv: '',
          cardBrand: '',
          formaPagamento: 'CARTAO_CREDITO',
          // campos que comecam com endereco, são obrigatorios quando boleto
          enderecoCep: '',
          enderecoRua: '',
          enderecoNumero: null,
          enderecoBairro: '',
          enderecoCidade: '',
          enderecoEstado: '',
          complemento: '',
          semNumero: false,
          precoTotal: '',
          quantidadeDeCreditos: '',
          plano: '',
          informacoesCliente: '',
        }),
        showModalConfirmarCompra: false,
        buying: false,
        beginCheckout: false,
      }
    },
    watch: {
      sliderValue(val) {
        this.creditos = parseFloat(val);
      }
    },
    computed: {
      sliderMove() {
        return (this.sliderValue * 100 / this.precoMaximo);
      },
      limites() {
        return Object.values(this.planos).reduce((acc, item) => {
          acc.push(item);
          return acc;
        }, []).reverse();
      },
      cardYears() {
        const year = new Date().getFullYear();
        return new Array(31).fill().map((_, i) => i + year);
      },
      cardBrand() {
        const knownBrands = ['visa', 'elo', 'mastercard', 'diners', 'amex'];
        const cardNumber = this.cardNumber.replace(new RegExp(' ', 'g'), '');

        if (cardNumber !== '') {
          const brand = Iugu.utils.getBrandByCreditCardNumber(cardNumber);
          if (knownBrands.indexOf(brand) !== -1) {
            return brand;
          }
        }

        return '';
      },
      creditoInvalido(){
        return ( this.creditos > this.precoMaximo ||this.creditos < this.usuario.valorMinimoCompra || this.creditos == '' || isNaN(this.creditos));
      },
      pagamentoAntigo() {
        return (this.usuario.metodoPagamentoApiAntigo || this.usuario.metodoPagamentoApiAntigo === null);
      },
      bonus() {
        if (!this.pagamentoAntigo) {
          return 0;
        }

        if (this.creditos >= 2700) {
          return 0.25 * this.creditos
        } else if (this.creditos >= 1050) {
          return 0.11 * this.creditos
        }

        return 0;
      },
      valorFinal(){
          return Number((this.bonus + this.creditos).toFixed(2));
      },
      googleAnalyticsItems() {
        return [
          {
            item_id: "creditos-api",
            item_name: "Créditos API",
            item_category: "API",
            item_list_name: "Créditos API",
            affiliation: "Escavador",
            quantity: 1,
            price: this.creditos.toFixed(2),
          },
        ];
      },
    },
    mounted() {
      this.precoMaximo = 10000;
      let valorProximmaCompra = this.ultimaCompraValor;

      if (valorProximmaCompra < this.usuario.valorMinimoCompra) {
        valorProximmaCompra = this.usuario.valorMinimoCompra;
      }
      if (valorProximmaCompra > this.precoMaximo) {
        valorProximmaCompra = this.precoMaximo;
      }

      this.sliderValue = valorProximmaCompra;

      this.creditos = this.usuario.valorMinimoCompra;

      Iugu.setAccountID(process.env.MIX_IUGU_ID);

      if (process.env.MIX_APP_ENV !== 'production') {
        console.log('Iugu setting test mode');
        Iugu.setTestMode(true);
      }

      if (this.dadosCobranca) {
        this.form.nome = this.dadosCobranca.nome;
        this.form.cpfCnpj = this.dadosCobranca.cpf_cnpj;
        this.form.enderecoCep = this.dadosCobranca.cep;
        this.form.enderecoRua = this.dadosCobranca.rua;
        this.form.enderecoBairro = this.dadosCobranca.bairro;
        this.form.enderecoCidade = this.dadosCobranca.cidade;
        this.form.enderecoEstado = this.dadosCobranca.estado;
        this.form.complemento = this.dadosCobranca.complemento;
        this.form.enderecoNumero = this.dadosCobranca.numero;
        this.form.semNumero = !this.dadosCobranca.numero;
        this.form.informacoesCliente = this.dadosCobranca.informacoes_cliente;
      }

      this.verificarCnpj();

      window.dataLayer?.push({
        event: 'view_item',
        value: this.creditos.toFixed(2),
        currency: 'BRL',
        items: this.googleAnalyticsItems,
      })
    },
    methods: {
      updateInputCEP(e) {
        if (e.target.value.length >= 9) {
          if (this.pesquisandoCepId) {
            clearTimeout(this.pesquisandoCepId);
          }

          this.pesquisandoCepId = setTimeout(() => {
            this.buscaPorCep = true;
            usuarioApi
            .enderecoPorCep(this.form.enderecoCep)
            .then(({data}) => {
              this.form.enderecoRua = data.address.logradouro;
              this.form.complemento = data.address.complemento;
              this.form.enderecoBairro = data.address.bairro;
              this.form.enderecoCidade = data.address.localidade;
              this.form.enderecoEstado = data.address.estado;
              this.buscaPorCep = false;
            })
            .catch(() => (this.buscaPorCep = false));
          }, 300);
        }
      },
      loading() {
        return this.$store.state.loading;
      },
      hasError(inputName) {
        return {'is-danger': this.errors[inputName]};
      },
      openModal(event) {

        var fields = [
          'nome',
          'cpfCnpj',
          'telefoneArea',
          'telefone',
        ];

        var fieldsToTest = [];
        if (this.form.formaPagamento === 'CARTAO_CREDITO') {
          fieldsToTest = fields.concat(['cardNumber', 'cardHolderName', 'cardCvv']);
        }

        if (this.isCnpj || this.form.formaPagamento === 'BOLETO') {
          fieldsToTest = fields.concat(['enderecoCep', 'enderecoRua', 'enderecoBairro', 'enderecoCidade', 'enderecoEstado']);

          if (!this.form.semNumero) {
            fieldsToTest = fieldsToTest.concat(['enderecoNumero'])
          }
        }

        if (this.hasNoEmptyFields(fieldsToTest, null, {
          nome: "Nome Completo",
          cardNumber: "Número do Cartão",
          cardHolderName: "Nome no Cartão",
          cardCvv: "CVV",
          cpfCnpj: "CPF/CNPJ",
          enderecoCep: 'Cep',
          enderecoRua: 'Rua',
          enderecoNumero: 'Número',
          complemento: 'Complemento',
          enderecoBairro: 'Bairro',
          enderecoCidade: 'Cidade',
          enderecoEstado: 'Estado',
          telefoneArea: 'Área do Telefone',
          telefone: 'Telefone'
        })) {
          if (this.form.formaPagamento === 'CARTAO_CREDITO') {
            EventBus.$emit('loading-show');
            this.validarCartaoCredito();
          } else {
            this.showModalConfirmarCompra = true;
          }
          window.dataLayer?.push({
            event: 'add_to_cart',
            value: this.creditos.toFixed(2),
            currency: 'BRL',
            items: this.googleAnalyticsItems,
          })
        } else {
          EventBus.$emit('loading-hide');
        }
      },
      comprarCreditos() {
        this.buying = true;
        this.form.precoTotal = this.creditos;
        this.form.quantidadeDeCreditos = 100 * (this.creditos + this.bonus);
        this.form.cardLastFourDigits = this.cardNumber.slice(-4);

        this.form.submit('post', 'creditos').then((a) => {
          EventBus.$emit('close-modal');
          this.$store.dispatch('showLoadingMessage', {
            message: 'Solicitação realizada com sucesso!',
            type: 'done'
          });

          window.dataLayer?.push({
            event: 'conversion',
            send_to: 'AW-937879425/tm6PCKydqKIBEIHPm78D',
          });

          window.dataLayer?.push({
            event: 'purchase',
            transaction_id: a.faturaApiId,
            affiliation: 'Escavador',
            value: parseFloat(this.creditos.toFixed(2)),
            items: this.googleAnalyticsItems,
          });

          setTimeout(() => {
            this.buying = false;
            window.location.href = subdomainUrl('api', '/faturas');
          }, 150)
        }).catch(({ data, status }) => {
          EventBus.$emit('close-modal');
          this.buying = false;

          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: status,
            responseData: data
          });
        })
      },
      getErrorMessage(inputName) {
        if (this.errors[inputName]) {
          return this.errors[inputName].message;
        }
      },
      validarCartaoCredito() {
        const nomePedacos = this.form.cardHolderName.split(' ');
        const primeiroNome = nomePedacos[0];
        const ultimoNome = nomePedacos[1];
        const cardNumber = this.cardNumber.replace(new RegExp(' ', 'g'), '');

        if (!Iugu.utils.validateCreditCardNumber(cardNumber)) {
          EventBus.$emit('loading-hide');

          this.$store.dispatch('showLoadingMessage', {
            message: 'Número do cartão inválido.',
            type: 'danger'
          });

          return false;
        } else {
          this.message.fail.cardNumber = "";
        }

        if (!Iugu.utils.validateExpirationString(`${this.form.cardMonth}/${this.form.cardYear}`)) {
          EventBus.$emit('loading-hide');

          this.$store.dispatch('showLoadingMessage', {
            message: 'Data de validade inválida.',
            type: 'danger'
          });

          return false;
        }

        if (!Iugu.utils.validateCVV(this.form.cardCvv, this.cardBrand)) {
          EventBus.$emit('loading-hide');

          this.$store.dispatch('showLoadingMessage', {
            message: 'CVV do cartão inválido.',
            type: 'danger'
          });

          return false;
        }

        this.form.cardBrand = this.cardBrand;

        // cria o objeto creditCard do Iugu
        const cc = Iugu.CreditCard(
        this.cardNumber,
        this.form.cardMonth,
        this.form.cardYear,
        primeiroNome,
        ultimoNome,
        this.form.cardCvv
        );

        // envia os dados do cartao para o iugu, para pegar o token de pagamento
        Iugu.createPaymentToken(cc, res => {
          if (res.errors) {
            EventBus.$emit('loading-hide');
            this.$store.dispatch('showLoadingMessage', {
              message: 'Dados do cartão inválidos.',
              type: 'danger'
            });
            return false;
          } else {
            EventBus.$emit('loading-hide');
            this.form.cardPaymentToken = res.id;
            this.showModalConfirmarCompra = true;
            return true;
          }
        });
      },
      closeModal() {
        this.showModalConfirmarCompra = false;
      },
      verificarCnpj() {
        // se for cnpj, exibe campos de endereço
        if (validarCNPJ(this.form.cpfCnpj)) {
          this.isCnpj = true;
        } else {
          this.isCnpj = false;
        }
      },
      toggleSemNumero() {
        this.form.enderecoNumero = null;
        this.message.fail.enderecoNumero = '';
        this.form.semNumero = !this.form.semNumero;
      },
      creditsButton(inputType){
        let creditosAtuais = this.sliderValue === '' ? 0: parseInt(this.sliderValue);
        this.sliderValue = inputType === 'max'? this.precoMaximo : 100;
      },
      revisarCompra(){
        if (!this.creditoInvalido ) {
          this.openModal();
        }
      },
      identificarPreenchimentoFormulario() {
        if (!this.beginCheckout) {
            window.dataLayer?.push({
              event: 'begin_checkout',
              currency: 'BRL',
              items: this.googleAnalyticsItems,
            });
            this.beginCheckout = true
          }
        },
      }
    }
  </script>

<style lang="stylus">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.sifrao
  position absolute
  display block
  margin-top 9px
  margin-left 35%
.display-span
  display block
.bp
  position absolute
.bpr
  position absolute
  right 12px
  justify-content: flex-start
.form-box-margin > .btn
  margin-right 0px
.form-box-width
  max-width 350px !important
.no-padding
  padding 0!important
.form-creditos
  max-width 100%
  .label
    padding 0
    display block
    color #898989
    text-align left
    font-size 0.875rem
    line-height 1.3
    margin-bottom 6px
    &.heading
      margin-bottom 0
.Message
  font-size 14px
  &.-fail
    color darken(rgb(238, 189, 101), 30)
.CardBrand
  background url('/assets/images/cc-brands.png') no-repeat
  width 22px
  height 22px
  position absolute
  transition background-position 0.2s ease-in
  bottom 20px
  margin-left 5px
  &.visa
    background-position-y: -22px
  &.elo
    background-position-y: -44px
  &.mastercard
    background-position-y: -66px
  &.diners
    background-position-y: -88px
  &.amex
    background-position-y: -110px
.CardNumber
  padding-left 35px

@media screen and (max-width: 991px)
  .CardNumber
    padding-left 30px
.box-minmax
  margin-top 30px
  width 608px
  display flex
  justify-content space-between
  font-size 20px
  color #FFFFFF
  span:first-child
    margin-left 10px
.range-slider
  margin 8px auto 0px
.rs-range
  margin-top 8px
  width 100%
  -webkit-appearance none
  border none
  &:focus
    outline none
  &::-webkit-slider-runnable-track
    width 100%
    height 1px
    cursor pointer
    box-shadow none
    background #333
    border-radius 0
    border 0 solid #333
  &::-moz-range-track
    width 100%
    height 1px
    cursor pointer
    box-shadow none
    background #333
    border-radius 0
    border 0 solid #333
  &::-webkit-slider-thumb
    border 0 solid #333
    box-shadow 0 2px 2px rgba(0,0,0,0.25)
    height 18px
    width 18px
    border-radius 22px
    background #1f8199
    cursor pointer
    -webkit-appearance none
    margin-top -8px
  &::-moz-range-thumb
    border 0 solid #333
    box-shadow 0 10px 10px rgba(0,0,0,0.25)
    height 18px
    width 18px
    border-radius 22px
    background #1f8199
    cursor pointer
    -webkit-appearance none
    margin-top -8px
  &::-moz-focus-outer
    border: 0
.rs-label
  position relative
  -webkit-transform-origin center center
  transform-origin center center
  display block
  width 70px
  height 50px
  background #FFF
  border-radius 5px
  text-align center
  padding-top 4px
  -webkit-box-sizing border-box
  box-sizing border-box
  border 2px solid #333
  margin-top 20px
  margin-left -30px
  left attr(value)
  color #333
  font-style normal
  font-weight normal
  line-height normal
  font-size 20px
  &::after
    content "R$"
    display block
    font-size 12px
    letter-spacing 0.07em
    margin-top -2px
.like-tooltip
  font-size 0.875rem
  border 1px solid #e0e0e0
  font-weight normal
  line-height 1
  padding 12.5px 18px
  top 15px
  left 153px
  background-color #FFF
  z-index 5
  border-radius 4px
.like-tooltip-line
  display block
  margin 14px 0
.Form__number
  display flex
  align-items center
  margin-top 29px
  .label
    cursor pointer
    margin-left 4px
  input
    width auto
    min-height auto
    margin-bottom 5px
.label
  &.label-title
    padding 0
    color #333
    font-size 100%
.Section__cartao
  margin-top 1rem

.descricao-desconto
  font-size 14px

@media screen and (max-width 768px)
  .rs-label
    position static
    margin-left auto
    margin-right auto
</style>
